import 'rxjs/add/operator/toPromise';
import { Injectable, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Api } from '../api/api';
import { ToastController, Nav,AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 */
@Injectable()
export class User {
  _user: any;
  // Our translated text strings
  @ViewChild(Nav) nav: Nav;

  constructor(
    public api: Api,
    public translateService: TranslateService,
    public toastCtrl: ToastController,
    public storage: Storage,
    private alertCtrl: AlertController) { 
      /*this.translateService.get('LOGIN_ERROR').subscribe((value) => {
        this.loginErrorString = value;
      })
      */
   }

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    let seq = this.api.post('login.php', accountInfo).share();

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status == 'success') {
        this._loggedIn(res);

      } else {
          this.storage.set('UserData',null)

         let toast = this.toastCtrl.create({
            message: res.raison,
            duration: 3000,
            position: 'top'
          });
          toast.present();
      }
    }, err => {
         console.error('ERROR', err);
         let toast = this.toastCtrl.create({
            message: 'erreur ds la requete:',
            duration: 30000,
            position: 'top'
          });
          toast.present();    

    });
    return seq;
  }

  logout() {
    this.storage.set('UserData',null)
    this.storage.set('token',null)
    this.storage.set('user',null)
  }

  ErrorAlert(msg) {
    let alert = this.alertCtrl.create({
      title: 'Erreur',
      subTitle: JSON.stringify(msg),
      buttons: ['Dismiss']
    });
    alert.present();
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    var token = resp.token;
    var user = resp.user;
    var prenom = resp.prenom;
    var agence = resp.agence;
    var level = resp.level;
    var type = resp.type;
      let toast = this.toastCtrl.create({
        message: "Bonjour "+prenom+" !",
        duration: 3000,
        position: 'top'
      });
      toast.present();
    //this.nav.push(MainPage);

    //localStorage.setItem('UserData',JSON.stringify(resp))
    localStorage.setItem('token',token)
    localStorage.setItem('user',user)
    localStorage.setItem('prenom',prenom)
    localStorage.setItem('agence',agence)
    localStorage.setItem('level',level)
    localStorage.setItem('type',type)

    //this.storage.set('UserData', JSON.stringify(resp));
    this.storage.set('token', token);
    this.storage.set('user', user);
    this.storage.set('prenom', prenom);
    this.storage.set('agence', agence);
    this.storage.set('level', level);
    this.storage.set('type', type);
    this.storage.set('annuls', false);
    //console.log('Just Set : ' + this.storage.get('UserData'))
    
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts